var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flex items-center whitespace-no-wrap",class:!_vm.isFee
      ? {
          'text-red': _vm.isOutgoing,
          'text-green': _vm.isIncoming,
        }
      : ''},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      trigger: 'hover click',
      content: _vm.source && _vm.price ? _vm.readableCurrency(_vm.source, _vm.price) : '',
      placement: _vm.tooltipPlacement,
    }),expression:"{\n      trigger: 'hover click',\n      content: source && price ? readableCurrency(source, price) : '',\n      placement: tooltipPlacement,\n    }"}],staticClass:"ml-auto"},[_vm._v(" "+_vm._s(_vm.readableCrypto(_vm.source))+" ")]),(_vm.showAmountInformation)?_c('SvgIcon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      trigger: 'hover click',
      content: _vm.$t('TRANSACTION.AMOUNT_TO_SELF', { amount: _vm.readableCrypto(_vm.amountToSelf) }),
    }),expression:"{\n      trigger: 'hover click',\n      content: $t('TRANSACTION.AMOUNT_TO_SELF', { amount: readableCrypto(amountToSelf) }),\n    }"}],staticClass:"ml-2",attrs:{"name":"information","view-box":"0 0 16 16"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }